import { useContext } from '@nuxtjs/composition-api'

export function replaceLinks(text: string) {
  const {
    app: { localePath },
  } = useContext()

  const links: string[] | null = text.match(/{Url-([a-zA-Z0-9]+)}/g)

  for (const linkIdx in links) {
    text = text.replace(
      links[linkIdx as any],
      localePath(
        links[linkIdx as any].substr(5, links[linkIdx as any].length - 6)
      )
    )
  }

  return text
}
